import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
    theme:{
        themes:{
            light:{
                primary: colors.blueGrey.base,
                secondary: colors.blueGrey.base,
                accent: colors.blueGrey.base
            },
        },
    },
});
